import React from 'react';

const LoadingIndicator = ({ isLoading, message }) => {
  if (!isLoading) return null;

  return (
    <div className="mx-2 my-2 p-3 bg-blue-50 rounded-lg text-sm text-blue-700">
      <div className="flex items-center gap-2 mb-1">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-700"></div>
        <span className="font-medium">
          {typeof message === 'string' ? message : 'Loading boundary data...'}
        </span>
      </div>
      {typeof message === 'string' && (
        <div className="text-xs text-blue-600 ml-6">
          Fetching boundaries sequentially to avoid rate limits
        </div>
      )}
    </div>
  );
};

export default LoadingIndicator;